import { CloseCircle } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";

/** The composer's × on a preview card: removes the card, keeps the link text. */
const PreviewDismissButton = ({ onPress }: Readonly<{ onPress: () => void }>) => {
  const { t } = useTranslation();
  return (
    <Pressable
      onPress={(event) => {
        event?.stopPropagation?.();
        onPress();
      }}
      hitSlop={8}
      className="absolute top-1.5 right-1.5 rounded-full bg-black/55 p-0.5 web:cursor-pointer"
      accessibilityRole="button"
      accessibilityLabel={t("LABEL_REMOVE_LINK_PREVIEW")}
      testID="link-preview-dismiss"
    >
      <CloseCircle size={20} color="white" />
    </Pressable>
  );
};

export default PreviewDismissButton;
